import { getActionBaseProvider } from "../../../../Application/actions/actionsBuilder";
import { commonActionTypes } from "../actionTypes/commonEventActionTypes";

export const discardAction = getActionBaseProvider(commonActionTypes.discard);
